<template>
  <v-row>
    <v-col cols="12">
      <v-simple-table dense width="100%" class="mt-2 dense_table bordered--table no-padding" v-for="(report, i) in deviationReport" :key="i">
        <thead>
          <tr>
            <th>{{ $t('message.deviations.categories') }}</th>
            <th class="text-center" colspan="2" v-for="(month, j) in report.monthorquateroryearlist" :key="j">
              {{ getPeriodName(month, groupby) }}
            </th>
            <template v-if="groupby !== 'YEAR'">
              <th colspan="2" class="text-center">{{report.year}}</th>
            </template>
          </tr>
        </thead>
        <tbody>
            <tr v-for="(data, i) in report.deviationreports" :key="`${i}_category`">
              <td width="15%">{{ data.categoryname }}</td>
              <template v-for="(month, j) in data.monthorquateroryeardata">
                <td width="3%" :key="`${j}_total`" class="text-right">
                  {{ month.totalcount }}
                </td>
                <td width="3%" :key="`${j}_percentage`" class="text-right">
                  {{ month.percentage }}%
                </td>
              </template>
              <template v-if="groupby !== 'YEAR'">
                <td width="3%" class="text-right">
                  {{ data.totalperyear }}
                </td>
                <td width="3%" class="text-right">
                  {{ data.totalpercentageperyear }}%
                </td>
              </template>
            </tr>
            <tr>
              <td>{{ $t('message.deviations.internalCost') }}</td>
              <template v-for="(data, j) in report.internalcostdetails">
                <td width="3%" :key="`${j}_interal`" class="text-right">
                  {{ data | replaceDotWithCommaIfHasDecimal }}
                </td>
                <td width="3%" :key="`${j}_percentage`" class="text-right">
                </td>
              </template>
              <template v-if="groupby !== 'YEAR'">
                <td width="3%" class="text-right">
                  {{ report.internalcosttotal | replaceDotWithCommaIfHasDecimal }}
                </td>
                <td width="3%" class="text-right">
                </td>
              </template>
            </tr>
            <tr :key="`${i}_customer`">
              <td>{{ $t('message.deviations.customerCost') }}</td>
              <template v-for="(data, j) in report.customercostdetails">
                <td width="3%" :key="`${j}_customer`" class="text-right">
                  {{ data | replaceDotWithCommaIfHasDecimal }}
                </td>
                <td width="3%" :key="`${j}_percentage`" class="text-right">
                </td>
              </template>
              <template v-if="groupby !== 'YEAR'">
                <td width="3%" class="text-right">
                  {{ report.customercosttotal | replaceDotWithCommaIfHasDecimal }}
                </td>
                <td width="3%" class="text-right">
                </td>
              </template>
            </tr>
        </tbody>
      </v-simple-table>
    </v-col>
  </v-row>
</template>
<script>
import moment from 'moment'
export default {
  props: ['deviationReport', 'groupby'],
  methods: {
    getPeriodName (periodNumber, type) {
      if (type === 'MONTH') {
        let lang = this.$i18n.locale === 'en' ? 'en' : 'nb'
        let list = moment.localeData(lang).months()
        return list[periodNumber - 1]
      } else if (type === 'QUARTER') {
        return `Q${periodNumber}`
      } else {
        return periodNumber
      }
    }
  }
}
</script>
<style>
.no-padding th, .no-padding td {
  padding: 4px !important;
}
</style>
